import { ConfigurationMapper } from './configuration';
import { EmailDocumentFieldOption, EmailDocument } from '../../../models';
import {
  EmailDocumentFieldOptionResponse,
  EmailDocumentValue,
  EmailDocument as OctopusEmailDocument,
} from '../models';

// Octopus returns single-select table fields (Category/Result) as an array of
// selected value ids (e.g. ["1"]), not a bare string. The domain contract and
// the single-select dropdowns downstream expect a primitive, so collapse the
// selector shape to its first value here.
export function toSelectorValue(
  field: EmailDocumentValue | undefined,
): string | null {
  if (Array.isArray(field)) {
    return field.length > 0 ? String(field[0]) : null;
  }
  return field ?? null;
}

export class EmailDocumentMapper extends ConfigurationMapper<
  OctopusEmailDocument,
  EmailDocument
> {
  from(source: OctopusEmailDocument): EmailDocument {
    return {
      id: source.Key ?? '',
      name: source.Name,
      binaryDataId: source.BinaryDataId,
      dateTime: new Date(source.DateTime),
      size: source.Size,
      parentKey: source.ParentKey,
      description: source.Description ?? '',
      canUpdate: source.SecStatus?.CanUpdate ?? false,
      result: toSelectorValue(source.Result),
      category: toSelectorValue(source.Category),
      readAccess: source.SecAccess?.Read?.[0]?.Key?.Value ?? '',
      fullAccess: source.SecAccess?.Write?.[0]?.Key?.Value ?? '',
      readAccessUid: source.SecAccess?.Read?.[0]?.Key?.Uid ?? '',
      fullAccessUid: source.SecAccess?.Write?.[0]?.Key?.Uid ?? '',
    };
  }
}

export class EmailDocumentFieldOptionMapper extends ConfigurationMapper<
  EmailDocumentFieldOptionResponse,
  EmailDocumentFieldOption
> {
  from(source: EmailDocumentFieldOptionResponse): EmailDocumentFieldOption {
    const emailDocument = source.EmailDocument?.FieldOptions;

    return {
      result: emailDocument?.Result?.map(this.mapValueAndDisplay) ?? [],
      category: emailDocument?.Category?.map(this.mapValueAndDisplay) ?? [],
      readAccess:
        emailDocument?.SecAccess?.Read?.map(this.mapSecurityAccess) ?? [],
      fullAccess:
        emailDocument?.SecAccess?.Write?.map(this.mapSecurityAccess) ?? [],
    };
  }
}
